module.exports = __webpack_public_path__ + "img/huopinguanli-b.a254266e.svg";